<template>
  <div class="content__thumb flex-none" :style="imageStyle"></div>
</template>

<script>
export default {
  props: {
    image: {
      validator: prop => typeof prop === 'object' || prop === null,
      required: true
    }
  },

  computed: {
    imageStyle() {
      if (!this.image) return

      return `--thumb-url: url("${this.image.thumb}")`
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  &__thumb {
    @apply h-10;
    @apply w-10;
    @apply bg-gray-500;

    object-fit: cover;
    background-image: var(--thumb-url);
    background-size: cover;
    background-position: center center;

    @apply rounded;
  }
}
</style>
